import React from 'react';
import styled from 'styled-components';
import JIDRCurrencyPngSrc from '../../assets/images/JIDRCurrency.png';
import {
  Container,
  IconContainer,
  CryptoIcon,
  AmountContainer,
  AmountText,
  TickerContainer,
  TickerText
} from './CryptoInputDisplay.styles';

const JIDRCurrencyPng = styled.img.attrs({
  src: JIDRCurrencyPngSrc,
})``;

export type CryptoInputDisplayProps = {
  iconUrl?: string;
  ticker?: string;
  amount?: string;
};

const CryptoInputDisplay: React.FC<CryptoInputDisplayProps> = ({
  iconUrl,
  ticker,
  amount,
}) => {
  return (
    <Container>
      <IconContainer>
        {iconUrl && (
          <CryptoIcon
            src={iconUrl}
            alt={`${ticker} icon`}
          />
        )}
        {!iconUrl && <JIDRCurrencyPng width={24} height={24} />}
      </IconContainer>
      <AmountContainer>
        <AmountText>
          {amount || 0}
        </AmountText>
      </AmountContainer>
      <TickerContainer>
        <TickerText>
          {ticker || 'JIDR'}
        </TickerText>
      </TickerContainer>
    </Container>
  );
}

export default CryptoInputDisplay;
